module.exports = __webpack_public_path__ + "static/media/virtual_doc_profile.b2e2ef5e.svg";